import io from "socket.io-client";

const isDevelopment =
  import.meta.env.VITE_APP_ENV === "development";

const server = isDevelopment
  ? import.meta.env.VITE_APP_STREAM_SERVER
  : import.meta.env.VITE_APP_SERVER;

export const recordingSocket = io(server, {
  path: isDevelopment
    ? "/socket.io"
    : "/streaming/socket.io",
  transports: ["websocket"],
});